import {useEffect} from 'react';
import WebFont from 'webfontloader';
import {AstView} from 'rendition-core/types';

export function getFontStrings(view: AstView) {
    const fontsObject = view.meta.fontsUsed.reduce<{[key: string]: string[]}>((acc, font) => {
        if (acc[font.family]) {
            acc[font.family].push(font.style);
        } else {
            acc[font.family] = [font.style];
        }
        return acc;
    }, {});

    const fontStrings = Object.keys(fontsObject).map((family) => {
        return `${family}:${fontsObject[family].join(',')}`;
    });

    fontStrings.push('Poppins');
    return fontStrings;
}

export function loadFonts(view: AstView) {
    const fontStrings = getFontStrings(view);

    loadFontWithDuplicatePrevention(fontStrings);
}

export const useLoadFonts = (view: AstView) => {
    useEffect(() => {
        loadFonts(view);
    }, [view]);
};

const LOADED_FONTS: Record<string, boolean> = {};

export const loadFontWithDuplicatePrevention = (key: string | string[]) => {
    const fontsToLoad: string[] = [];
    if (Array.isArray(key)) {
        key.forEach((k) => {
            if (!LOADED_FONTS[k]) {
                fontsToLoad.push(k);
            }
        });
    } else {
        if (!LOADED_FONTS[key]) {
            fontsToLoad.push(key);
        }
    }

    if (fontsToLoad.length > 0) {
        WebFont.load({
            google: {
                families: fontsToLoad,
            },
        });

        fontsToLoad.forEach((k) => {
            LOADED_FONTS[k] = true;
        });
    }
};

export const loadFontByName = (family: string, style: string | number) =>
    loadFontWithDuplicatePrevention(`${family}:${style}`);
